<template>
  <li
    class="leading-none text-xs overflow-x-scroll scrollbar-hide"
    :class="{
      'bg-white text-primary font-bold': category.no == $route.query.category,
    }"
  >
    <a href="#" class="py-4 block text-center" @click.prevent="switched">{{
      category.name
    }}</a>
  </li>
</template>

<script>
export default {
  props: {
    category: Object,
    isActive: Boolean,
  },
  methods: {
    switched() {
      this.mapQuery({
        category: this.category.no,
        title: this.category.name,
      });
    },
  },
};
</script>
